const css = `.switch {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
}
.switch label {
  color: var(--text);
  font-weight: var(--font-weight-medium);
}
.switch.indent-1 {
  margin-left: var(--gap);
}
.switch.indent-2 {
  margin-left: calc(2 * var(--gap));
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvU3dpdGNoIiwic291cmNlcyI6WyJTd2l0Y2guc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7RUFDQTs7QUFHRjtFQUNFOztBQUVGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuc3dpdGNoIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiA4cHg7XG4gIG1hcmdpbjogNHB4IDA7XG4gIGxhYmVsIHtcbiAgICBjb2xvcjogdmFyKC0tdGV4dCk7XG4gICAgZm9udC13ZWlnaHQ6IHZhcigtLWZvbnQtd2VpZ2h0LW1lZGl1bSk7XG4gIH1cblxuICAmLmluZGVudC0xIHtcbiAgICBtYXJnaW4tbGVmdDogdmFyKC0tZ2FwKTtcbiAgfVxuICAmLmluZGVudC0yIHtcbiAgICBtYXJnaW4tbGVmdDogY2FsYygyICogdmFyKC0tZ2FwKSk7XG4gIH1cbn1cbiJdfQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
